import { render, staticRenderFns } from "./ServiceMethodForm.vue?vue&type=template&id=5cb21af6"
import script from "./ServiceMethodForm.vue?vue&type=script&lang=js"
export * from "./ServiceMethodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports